/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
export { a as addIcons, g as getIconMap, i as i18n } from './utils-4faf1901.js';
export { a as addCachedAssets, g as getAssetsCacheMap } from './assets-helper-0799bcae.js';

const setupConfig = (config) => {
  const win = window;
  const Larva = win.Larva;
  if (Larva && Larva.config && Larva.config.constructor.name !== 'Object') {
    console.error('Larva config was already initialized');
    return;
  }
  win.Larva = win.Larva || {};
  win.Larva.config = Object.assign(Object.assign({}, win.Larva.config), config);
  return win.Larva.config;
};

export { setupConfig };

//# sourceMappingURL=index.js.map